/* Dansk katalog for locale-settings-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'set.acc.assetAutomaticPostingExplanation': 'Afskrivninger bogføres automatisk for hver afsluttet måned. Plumme indhenter manglende måneder, uden at du behøver at gøre noget.',
  'set.acc.paymentDays': 'Standardbetalingsfrist (dage)',
  'set.acc.paymentDaysHelp': 'Forfaldsdatoen følger fakturadatoen med denne frist. Du kan tilsidesætte forfaldsdatoen på den enkelte faktura.',
  'set.acc.paymentDaysInvalid': 'Vælg en betalingsfrist fra 0 til 365 hele dage.',
  'set.acc.foreignCurrencyInvoices': 'Fakturaer i udenlandsk valuta',
  'set.acc.foreignCurrencyInvoicesHelp': 'Vis dokumentvaluta og kursfelter i Nyt salg. Lad dette være slået fra, hvis du kun fakturerer i regnskabsvalutaen.',
  'set.acc.advancedVatDeduction': 'Avanceret momsfradrag på købslinjer',
  'set.acc.advancedVatDeductionHelp': 'Vis valg for helt eller delvist fradrag, når dokumentet har moms. Valget er normalt 100 %, og eksisterende afvigelser vises altid.',
  'set.acc.openingAssets': 'Driftsmidler i åbningsbalancen',
  'set.acc.openingAssetsHelp': 'Registrer detaljerne for aktiver, der allerede indgår i åbningsbalancen. Beløbene afstemmes mod åbningsbalancen, men aktiverne føres i aktivregisteret.',
  'set.acc.openingAssetsAction': 'Registrer eksisterende driftsmiddel',
  'set.acc.assetAutomation': 'Automatisk månedlig bogføring af afskrivninger',
  'set.acc.assetAutomationHelp': 'Kontroller beløb og periode, før du bekræfter. Aktivering bogfører udestående afsluttede måneder og godkender fortsat automatik. Pause fjerner ingen bogførte bilag.',
  'set.acc.assetAutomationActive': 'Aktiv for det valgte regnskabsår.',
  'set.acc.assetAutomationOff': 'Deaktiveret for det valgte regnskabsår.',
  'set.acc.assetAutomationReview': 'Sat på pause. Kontroller og godkend det opdaterede aktivgrundlag før fortsat automatisk bogføring.',
  'set.acc.assetAutomationEnableNote': 'Godkendt automatisk månedlig bogføring af regnskabsmæssige afskrivninger.',
  'set.acc.assetAutomationDisableNote': 'Automatisk månedlig bogføring stoppet af brugeren.',
  'set.bank.activeFromHelp': 'Opfølgningen forventer kun kontoudtog fra denne dato og fremefter.',
  'set.bank.noReconciliationHelp': 'Uden bankafstemning skal du selv kontrollere, at alle bankbevægelser er bogført én gang, at banksaldoen stemmer med regnskabet, og at private og virksomhedsrelaterede betalinger ikke blandes.',
  'set.bank.newAccount': 'Ny bankkonto',
  'set.bank.invoiceDeleteBlocked': 'Fakturakontoen kan ikke slettes, før en anden konto er valgt',
  'set.bank.deleteOrDisable': 'Slet eller deaktiver konto',
  'set.bank.openingBalanceHelp': 'Bankens saldo ved udgangen af den seneste dato, der allerede er afstemt. Den er kontrolanker for bankafstemningen, men bogfører ikke åbningsbalance; IB føres under Regnskab med en modkonto.',
  'set.bank.openingBalanceDateHelp': 'Plumme begynder bankafstemningen dagen efter denne dato.',
  'set.bank.setupValidation.date': "Vælg en gyldig dato.",
  'set.bank.setupValidation.year': "Datoen skal ligge i regnskabsår {year}. Skift regnskabsår for en anden start.",
  'set.bank.setupValidation.amount': "Indtast bankens dokumenterede saldo. Indtast 0 hvis kontoen var tom.",
  'set.bank.setupValidation.counter': "Vælg modkonto fra den dokumenterede åbningsbalance.",
  'set.bank.setupTitle': 'Opsæt startsaldo',
  'set.bank.setupIntro': 'Registrer bankens dokumenterede saldo og den afstemte bogføring i ét flow. Plumme gætter aldrig modkonto.',
  'set.bank.setupYearStart': 'Start ved nyt regnskabsår',
  'set.bank.setupYearStartHelp': 'Brug saldoen ved udgangen af det foregående år som bankens IB i det nye år.',
  'set.bank.setupMidYear': 'Flyt til Plumme midt i året',
  'set.bank.setupMidYearHelp': 'Brug saldoen dagen før Plumme overtager bogføringen.',
  'set.bank.setupNewAccount': 'Ny bankkonto i et løbende regnskab',
  'set.bank.setupNewAccountHelp': 'En overførsel til en ny konto er en almindelig transaktion, ikke åbningsbalance.',
  'set.bank.setupUnsupported': 'Samlet startsaldo for bank og regnskab understøttes indtil videre kun for norske NOK-konti. Brug de separate regnskabs- og bankflows for denne konto.',
  'set.bank.setupNewAccountTitle': 'Bogfør den faktiske overførsel',
  'set.bank.setupNewAccountBody': 'Opret eller importer den transaktion, der flyttede pengene til kontoen. Når hovedbogen stemmer med banken, kan bankafstemningen starte uden en ny åbningsbalance.',
  'set.bank.setupTransitionDate': 'Første dag i Plumme',
  'set.bank.setupTransitionYearHint': "F\u00f8rste dag i det valgte regnskabs\u00e5r. ({year})",
  'set.bank.setupTransitionMidYearHint': 'Datoen, hvor Plumme overtager fra det tidligere system.',
  'set.bank.setupEvidenceDate': 'Bankens saldo pr.',
  'set.bank.setupEvidenceDateHint': 'Beregnes som dagen før Plumme overtager.',
  'set.bank.setupBankBalance': 'Bankens dokumenterede saldo',
  'set.bank.setupBankBalanceHint': 'Brug saldoen fra kontoudtoget på skæringsdatoen.',
  'set.bank.setupLedgerAccount': 'Bankkonto i hovedbogen',
  'set.bank.setupCounterAccount': 'Modkonto i åbningsbalancen',
  'set.bank.setupCounterHelp': 'Vælg, hvor bankbeløbet kommer fra. Det kan ikke afgøres af banksaldoen alene.',
  'set.bank.setupChooseCounter': 'Vælg modkonto',
  'set.bank.setupNoCounter': 'Ingen modkonto nødvendig ved nulsaldo',
  'set.bank.setupNoCounterMatches': 'Ingen balancekonti matcher søgningen.',
  'set.bank.setupManagedInBank': 'Koblet til startsaldoen under Indstillinger - Bank',
  'set.bank.setupMidYearWarning': 'Banksaldoen er kun én del af overgangen. Indtast eller importer også øvrige balance-, resultat- og momstal fra det tidligere system under Regnskab.',
  'set.bank.setupPreview': 'Dette gemmes samlet',
  'set.bank.setupPreviewText': 'Bankbevis: {amount} pr. skæringsdato. Regnskabs-IB: {bank} mod {counter}.',
  'set.bank.setupNotChosen': 'modkonto ikke valgt',
  'set.bank.setupSave': 'Gem startsaldo og IB',
  'set.bank.setupSaveError': 'Kunne ikke gemme startsaldoen.',
  'set.bank.setupPostingNote': 'Bankens startsaldo – {account}',
  'set.bank.setupButton': 'Opsæt eller ret startsaldo',
  'set.bank.setupSummaryTitle': 'Bankens saldo ved opstart',
  'set.bank.setupSummaryEmpty': 'Startsaldo og regnskabs-IB er ikke opsat.',
  'set.bank.setupSummaryValue': '{amount} pr. {date}',
  'set.bank.setupSaved': 'Startsaldo og åbningsbalance er gemt',
  'set.bank.setupSaveAccountFirst': 'Gem bankkontoen først. Derefter kan startsaldo og åbningsbalance opsættes samlet.',
  'set.bank.iban': 'IBAN',
  'set.bank.bic': 'BIC',
  'set.bank.showIbanBicOnInvoice': 'Vis IBAN og BIC på fakturaen',
  'set.role.owner': 'Ejer',
  'set.access.noOrgNumber': 'Uden org.nr.',
  'set.access.onboardingUnavailable': 'Onboarding er ikke indlæst.',
  'set.access.members': 'Medlemmer',
  'set.access.membersSub': 'Ejer og administratorer kan fjerne aktive adgange. Ejerskabet skal overdrages, før ejerens egen adgang kan fjernes.',
  'set.access.membersOnlyAdmin': 'Kun ejer og administrator kan administrere medlemmer.',
  'set.access.selfRemoveHelp': 'Du kan alligevel fjerne din egen adgang, hvis du ikke er ejer.',
  'set.access.you': 'dig',
  'set.access.remove': 'Fjern',
  'set.access.membersEmpty': 'Aktive medlemmer vises for ejer og administrator.',
  'set.access.removeSelf': 'Fjern min adgang',
  'set.access.transferTitle': 'Overdrag ejerskab',
  'set.access.transferSub': 'Send en kontrolleret invitation til den nye ejer. Ejerskabet flyttes først, når modtageren logger ind og accepterer.',
  'set.access.transferOnlyOwner': 'Kun ejeren kan overdrage ejerskab.',
  'set.access.transferAdminHelp': 'Administratorer kan invitere samarbejdspartnere, men kan ikke skifte ejer.',
  'set.access.newOwnerEmail': 'Ny ejers e-mail',
  'set.access.afterTransferRole': 'Din adgang efter overdragelsen',
  'set.access.roleAdministrator': 'Administrator',
  'set.access.transferReason': 'Årsag / note til revisionsspor',
  'set.access.transferReasonPlaceholder': 'F.eks. solgt virksomheden eller oprettet for en kunde',
  'set.access.sendTransfer': 'Send ejerskifte',
  'set.access.ownershipTransfer': 'Ejerskifte',
  'set.access.expired': 'Udløbet',
  'set.access.viewAccept': 'Se og acceptér',
  'set.access.unknown': 'ukendt',
  'set.access.resend': 'Send igen',
  'set.tab.accounting': 'Regnskab',
  'set.tab.data': 'Data',
  'set.companyEmailHint': 'Hentes fra dit login.',
  'set.countryLocked': 'Land vælges, når virksomheden oprettes, og kan ikke ændres her. Kontakt support ved fejl.',
  'set.inboxUpdatedAt': 'Senest opdateret {date}',
  'set.inboxCopied': 'E-mail kopieret',
  'set.profileEmailHint': 'E-mail ændres ikke her, da Firebase kan kræve et nyt login.',
  'set.subscriptionPlan': 'Plan: {plan}',
  'set.subscriptionInactive': 'Abonnement ikke aktiveret',
  'set.subscriptionTrialUntil': 'Prøveperiode til {date}',
  'set.subscriptionChooseHelp': 'Vælg en plan for at starte checkout i Stripe.',
  'set.subscriptionDisconnected': 'Ikke forbundet',
  'set.subscriptionCurrentPlan': 'Nuværende plan',
  'set.subscriptionChoosePlan': 'Vælg {name}',
  'set.subscriptionFeature.bookkeeping': 'Bogføring',
  'set.subscriptionFeature.invoiceEmailEhf': 'Faktura på e-mail og EHF',
  'set.subscriptionFeature.publicFiling': 'Indsendelse til myndighederne',
  'set.subscriptionFeature.invoiceEmail': 'Faktura på e-mail',
  'set.subscriptionFeature.taxFigures': 'Tal til moms og skattemelding',
  'set.subscriptionFeature.taxIntegration': 'Integration med Skatteetaten',
  'set.acc.setupTab': 'Opsætning',
  'set.acc.chartTab': 'Kontoplan',
  'set.acc.vatPeriodAnnual': 'Årlig',
  'set.acc.vatPeriodBimonthly': 'Hver anden md.',
  'set.acc.vatPeriodMonthly': 'Månedlig',
  'set.acc.vatPeriodQuarterly': 'Kvartalsvis',
  'set.acc.vatPeriod.monthly': 'Månedlig',
  'set.acc.vatPeriod.bimonthly': 'Hver anden måned',
  'set.acc.vatPeriod.quarterly': 'Kvartalsvis',
  'set.acc.vatPeriod.semiannual': 'Halvårlig',
  'set.acc.vatPeriod.annual': 'Årlig',
  'set.acc.vatPeriodEffectiveYear': 'Gælder fra år',
  'set.acc.vatPeriodEffectiveYearHelp': 'Angiv det år, der står i afgørelsen fra Skatteetaten. Ændringen gælder fra 1. januar det år. Et afsluttet år skal genåbnes, og indsendte MVA-meldinger skal åbnes eller tilbageføres først.',
  'set.acc.vatPeriodEffectiveYearInvalid': 'Angiv et gyldigt årstal med fire cifre.',
  'set.acc.vatPeriodHistory': 'Historik for momsperiode',
  'set.acc.vatPeriodConfirmTitle': 'Er du sikker på, at momsperioden skal ændres?',
  'set.acc.vatPeriodConfirmText': 'Ændringen gælder fra 1. januar {year}. Kontrollér, at året stemmer med afgørelsen fra Skatteetaten. Tidligere år forbliver uændrede. Et afsluttet år skal genåbnes, og indsendte MVA-meldinger skal åbnes eller tilbageføres først.',
  'set.acc.vatPeriodConfirm': 'Bekræft ændring',
  'set.acc.notVatRegisteredNotice': 'Når virksomheden ikke er momsregistreret, sættes nye fakturaer til 0 % moms. Køb kan stadig registreres med moms på bilaget, men uden fradragsret.',
  'set.acc.midYearText': 'Brug dette, hvis du flytter til Plumme midt i året og vil have, at rapporterne fortsætter med tal fra det tidligere system.',
  'set.acc.openingSaved': 'Starttal gemt',
  'set.acc.openingSavedFrom': 'Starttal gemt fra {date}.',
  'set.acc.openingBalanceText': 'Brug dette, hvis du starter ved et nyt regnskabsår og vil indtaste åbningsbalancen fra det foregående år.',
  'set.startup.linkedBalanceTitle': 'Åbningsbalance følger med',
  'set.startup.linkedBalanceHelp': 'Det er de samme balancelinjer som i guiden til åbningsbalance. Banklinjer rettes under Indstillinger - Bank.',
  'set.acc.balanceBooked': 'Bogført {date} - {count} {lines}',
  'set.acc.line': 'linje',
  'set.acc.lines': 'linjer',
  'set.acc.enterAccountNumber': 'Indtast kontonummer',
  'set.acc.equivalentHint': 'Styrer behandlingen i årsafslutning og skattemelding.',
  'set.acc.saveChart': 'Gem kontoplan',
  'set.acc.equivalentShort': 'Svarer til',
  'set.acc.usedInHistory': 'Brugt i historik',
  'set.acc.activate': 'Aktivér',
  'set.acc.editAccount': 'Rediger konto',
  'set.acc.deactivateUsed': 'Deaktiver brugt konto',
  'set.acc.deleteUnused': 'Slet ubrugt konto',
  'set.ib.intro': 'Her indtaster du åbningsbalancen fra det forrige regnskabsår. Brug dette, når du starter ved et nyt år og vil have, at balancen stemmer fra dag ét i Plumme.',
  'set.ib.attachment': 'Vedhæftning',
  'set.ib.uploadDocuments': 'Upload dokumenter',
  'set.ib.uploading': 'Uploader...',
  'set.ib.created': 'Oprettet',
  'set.ib.uploadReceipt': 'Upload nyt bilag',
  'set.ib.emptyHelp': 'Du skal tilføje mindst én linje, før du kan oprette en åbningsbalance. Brug knappen "Tilføj ny linje" til at indtaste tallene fra det tidligere system.',
  'set.ib.postHelp': 'Bekræft, at åbningsbalancen er korrekt og klar til bogføring. Du kan stadig ændre den bagefter, så længe perioden er åben.',
  'set.ib.draftFor': 'Kladde til åbningsbalance for {date}',
  'set.ib.createdAt': 'Oprettet {date}',
  'set.ib.balanceHelp': 'Indtast saldoen for hver konto fra det afsluttede regnskab. Hele åbningsbalancen skal have samme sum i debet og kredit.',
  'set.ib.noteOptional': 'Bemærkning (valgfrit)',
  'set.ib.difference': 'Difference',
  'set.ib.saveDraft': 'Gem kladde',
  'set.ib.validationHelp': 'Kontrollér, at hver linje har en konto og et positivt beløb på kun én side, og at sum debet er lig med sum kredit.',
  'set.ib.excludedRows': '{count} resultat- eller ukendte konti holdes uden for den ordinære åbningsbalance. Kontrollér dem i importgrundlaget.',
  'set.transitionImport.confirmSigned': 'Bekræft kolonne og fortegn før import',
  'set.transitionImport.balanceColumn': 'Saldokolonne',
  'set.transitionImport.signConvention': 'Fortegnskonvention',
  'set.transitionImport.positiveDebit': 'Positivt er debet, negativt er kredit',
  'set.transitionImport.positiveCredit': 'Positivt er kredit, negativt er debet',
  'set.transitionImport.signExample': 'Eksempel: Med »positivt er debet« bliver −427 473,92 til kredit 427 473,92.',
  'set.transitionImport.confirmImport': 'Bekræft og vis eksempel',
  'set.transitionImport.helpImage': 'SAF-T, Excel, CSV eller billede. Træk ind, eller indsæt med Ctrl+V.',
  'sd.deleteAllTitle': 'Slet alle {label}',
  'sd.deleteAllMessage': 'Slet alle {label} ({count})? Historiske fakturaer og bilag bevares, men registret tømmes. Dette kan ikke fortrydes. Vi anbefaler, at du laver en eksport først.',
  'sd.label.customers': 'kunder',
  'sd.label.suppliers': 'leverandører',
  'sd.label.products': 'produkter',
  'sd.importing': 'Importerer...',
  'sd.documentReferenceMissing': 'Dokumentet mangler reference til importpakken.',
  'sd.documentLinkFailed': 'Kunne ikke hente dokumentlinket.',
  'sd.documentOpenFailed': 'Kunne ikke åbne importdokumentet.',
  'sd.kind.voucher': 'Bilag',
  'sd.kind.inbox': 'Indbakke',
  'sd.kind.bankReconciliation': 'Bankafstemninger',
  'sd.kind.company': 'Virksomhedsdokumenter',
  'sd.kind.invoice': 'Faktura',
  'sd.kind.quote': 'Tilbud',
  'sd.kind.creditNote': 'Kreditnota',
  'sd.kind.orderConfirmation': 'Ordrebekræftelse',
  'sd.kind.paymentReminder': 'Betalingspåmindelse',
  'sd.kind.otherCount': 'Andre {count}',
  'sd.kind.allCount': 'Alle {count}',
  'sd.reportCsv': 'Rapport CSV',
  'sd.reportXlsx': 'Rapport XLSX',
  'sd.openItems.exported': '{count} åbne poster eksporteret',
  'sd.openItems.exportFailed': 'Kunne ikke eksportere rapporten.',
  'sd.openItems.title': 'Kontrollér importerede åbne poster',
  'sd.openItems.count': 'åbne poster',
  'sd.openItems.remainingTotal': 'sum restbeløb',
  'sd.openItems.possibleDeviations': 'mulige afvigelser',
  'sd.openItems.search': 'Søg på navn, fakturanr., dato eller ark',
  'sd.filter.all': 'Alle',
  'sd.filter.customers': 'Kunder',
  'sd.filter.suppliers': 'Leverandører',
  'sd.openItems.checkDeviation': 'Tjek afvigelser mod kartotekssaldo',
  'sd.openItems.deviation': '{label}: {party} afviger med {amount}',
  'sd.unnamed': 'Uden navn',
  'sd.openItems.rowMeta': '#{invoice} · dato {date} · forfald {due}',
  'sd.openItems.empty': 'Ingen åbne importposter matcher filteret.',
  'sd.documents.title': 'Importeret dokumentarkiv',
  'sd.documents.count': 'dokumenter',
  'sd.documents.types': 'typer',
  'sd.documents.packages': 'eksportpakker',
  'sd.documents.search': 'Søg på fil, år, bilagsnr. eller intern sti',
  'sd.documents.sortType': 'Sortér: type',
  'sd.documents.sortYear': 'Sortér: år',
  'sd.documents.sortName': 'Sortér: filnavn',
  'sd.documents.basis': 'Arkivgrundlag',
  'sd.documents.basisHelp': 'Dokumenterne er gemt som importindeks mod den oprindelige eksportpakke. De opretter ikke automatisk fakturaer, køb, bilag eller elementer i indbakken.',
  'sd.documents.fallback': 'Dokument',
  'sd.documents.unknownPath': 'Ukendt sti i eksportpakken',
  'sd.documents.fetching': 'Henter...',
  'sd.documents.open': 'Åbn',
  'sd.documents.empty': 'Ingen importerede dokumenter matcher filteret.',
  'sd.ledger.title': 'Importeret hovedbogsarkiv',
  'sd.ledger.linesShown': 'historiklinjer i vist arkiv',
  'sd.ledger.debitShown': 'debet i vist udvalg',
  'sd.ledger.creditShown': 'kredit i vist udvalg',
  'sd.ledger.search': 'Søg på bilag, konto, tekst, dato eller kilde',
  'sd.ledger.allYears': 'Alle år',
  'sd.ledger.historyOnly': 'Kun historik',
  'sd.ledger.historyHelp': 'Linjerne her er et læsbart importarkiv fra det tidligere system. Summerne ovenfor er debet/kredit for det viste arkivudvalg, ikke omsætning. Linjerne indgår ikke i Plumme-rapporter, moms, skat, bankafstemning eller den aktive bilagsliste.',
  'sd.ledger.noText': 'Ingen tekst',
  'sd.ledger.linkedCount': '{count} tilknyttede bilag i dokumentarkivet',
  'sd.ledger.empty': 'Ingen importerede hovedbogslinjer matcher filteret.',
  'sd.ledger.linkedTitle': 'Tilknyttede bilag',
  'sd.ledger.archiveDocument': 'Arkivdokument',
  'sd.ledger.archiveDocumentHelp': 'Dette er dokumentreferencer fra den oprindelige eksportpakke. De opretter ikke aktive bilag eller elementer i indbakken.',
  'sd.ledger.noDocumentDetails': 'Ingen dokumentdetaljer gemt for denne linje.',
  'sd.ledger.showing': 'Viser {shown} af {total} resultater for denne historiklinje.',
  'sd.transition.exported': '{count} år eksporteret',
  'sd.transition.exportFailed': 'Kunne ikke eksportere overgangsrapporten.',
  'sd.transition.title': 'Afstemning og overgangsrapport',
  'sd.transition.years': 'år',
  'sd.transition.openingLines': 'Primolinjer',
  'sd.transition.historyLines': 'historiklinjer',
  'sd.transition.warnings': 'kontroladvarsler',
  'sd.transition.control': 'Overgangskontrol',
  'sd.transition.controlHelp': 'Rapporten sammenstiller importeret åbningsbalance, debitor-/kreditorbog, bank og hovedbogshistorik pr. år. Tallene er kontrolgrundlag og bogføres ikke automatisk.',
  'sd.transition.latestSubledger': 'Importeret debitor-/kreditorsaldo uden eget år vises på {year} som senest importerede debitor-/kreditorbog.',
  'sd.transition.rowSummary': '{opening} primolinjer · {accounts} historiske kontosaldi · {history} historiklinjer · bank primo {bank}',
  'sd.transition.warningCount': '{count} advarsel(er)',
  'sd.transition.discrepancy': 'Afvigelse {amount}',
  'sd.transition.historicalBalance': 'Historisk saldo',
  'sd.transition.balanceSequence': 'Primo / ændring / ultimo',
  'sd.transition.historicalResult': 'Historisk resultat',
  'sd.transition.incomeCost': 'Indtægt {income} · omkostning {cost}',
  'sd.transition.itemsDeviation': '{count} poster · afvigelse {amount}',
  'sd.transition.supplierSubledger': 'Kreditorbog',
  'sd.transition.ledgerArchive': 'Hovedbogsarkiv',
  'sd.transition.empty': 'Ingen importerede overgangstal at vise endnu.',
  'sd.vatTax.exported': '{count} linjer eksporteret',
  'sd.vatTax.exportFailed': 'Kunne ikke eksportere moms-/skattehistorikken.',
  'sd.vatTax.title': 'Moms og skat fra importhistorik',
  'sd.vatTax.periods': 'Momsperioder',
  'sd.vatTax.netVat': 'nettomoms',
  'sd.vatTax.resultBeforeTax': 'resultat før skat',
  'sd.vatTax.basis': 'Historisk kontrolgrundlag',
  'sd.vatTax.basisHelp': 'Momsen summeres fra importerede 270x/271x-konti pr. periode. SAF-T-momskoder vises som kodegrundlag, hvor eksportfilen indeholder dem. Dette opretter ikke nye MVA-meldinger, bilag eller skatteposteringer.',
  'sd.vatTax.yearSummary': '{count} perioder · resultat før skat {amount}',
  'sd.vatTax.archive': 'Arkiv',
  'sd.vatTax.period': 'Periode {number} · {label}',
  'sd.vatTax.outputInput': 'Udg. {output} · indg. {input}',
  'sd.vatTax.empty': 'Ingen importeret moms-/skattehistorik at vise endnu.',
  'sd.vatTax.codes': 'SAF-T-momskoder',
  'sd.vatTax.showing': 'Viser {shown} af {total}',
  'sd.vatTax.code': '{year}-{month} kode {code}',
  'sd.vatTax.baseVat': 'Grundlag {base} · moms {vat} · {rate}%',
  'sd.resetMessage': 'Dette sletter permanent alle regnskabs- og driftsdata i den valgte virksomhed: fakturaer, bilag, betalinger, kunder, leverandører, produkter, løn, bankdata, åbningsbalance, importarkiver, filer og alle løbenumre. Handlingen kan ikke fortrydes. Lav en komplet eksport først, hvis noget skal bevares.',
  'sd.resetPreserved': 'Selve virksomhedsprofilen, medlemmer, abonnement og integrationsforbindelser bevares. Brug «Slet virksomhed», hvis dette også skal fjernes.',
  'sd.resetPhrase': 'BEKRÆFT',
  'sd.resetTypeLabel': 'Skriv {phrase} for at aktivere nulstilling',
  'sd.resetTypeHint': 'Knappen forbliver deaktiveret, indtil teksten er skrevet præcist.',
  'sd.resetConfirm': 'Slet og nulstil alt',
  'sd.resetComplete': 'Alle regnskabs- og driftsdata er slettet. Virksomheden er nulstillet.',
  'sd.resetFailed': 'Kunne ikke gennemføre nulstillingen.',
  'sd.deleteBusinessMessage': 'Vil du planlægge sletning af den valgte virksomhed om 30 dage? Virksomheden, dataene og adgangen fjernes efter karensperioden. Du kan annullere sletningen før fristen.',
  'sd.deleteBusinessConfirm': 'Planlæg sletning',
  'sd.customersTitle': 'Import / Eksport af kunder',
  'sd.suppliersTitle': 'Import / Eksport af leverandører',
  'sd.productsTitle': 'Import / Eksport af produkter',
  'sd.invoicesTitle': 'Import / Eksport af fakturaer',
  'sd.vouchersTitle': 'Import / Eksport af bilag',
  'sd.supportedFormats': 'Understøttede importformater: .xlsx og .csv.',
  'sd.productsHelp': 'Importér og eksportér produkter med skabelonkolonner. Understøttede importformater: .xlsx og .csv.',
  'sd.invoicesHelp': 'Eksportér fakturaer som CSV, eller importér nye fakturaer med skabelon.',
  'sd.vouchersHelp': 'Eksportér bilagsoversigt eller bogføringslinjer. Import analyseres sikkert som en komplet eksportpakke.',
  'sd.importInvoices': 'Importér fakturaer',
  'sd.buildingExport': 'Bygger eksportpakke...',
  'sd.exportAll': 'Eksportér alt (.zip)',
  'sd.technicalJson': 'Teknisk JSON',
  'sd.analyzing': 'Analyserer...',
  'sd.importOtherSystem': 'Importér fra andet system',
  'sd.reviewOpenItems': 'Kontrollér åbne poster',
  'sd.documentArchive': 'Dokumentarkiv',
  'sd.ledgerArchive': 'Hovedbogsarkiv',
  'sd.transitionReport': 'Overgangsrapport',
  'sd.vatTaxHistory': 'Moms-/skattehistorik',
  'sd.latestAnalysis': 'Seneste analyse: {files} filer, {saft} SAF-T, {excel} Excel, {vouchers} bilagsfiler. Status: {status}.',
  'sd.analyzed': 'analyseret',
  'sd.reanalyze': 'Analysér samme fil igen',
  'sd.reread': 'Læs importfilen igen',
  'sd.rereadHelp': 'Den seneste importfil er gemt, men analysen er ikke færdig eller mislykkedes.',
  'sd.importProposal': 'Forslag: {accounts} saldokonti, {customers} kunder, {suppliers} leverandører, {products} produkter, {customerInvoices} åbne kundefakturaer, {supplierInvoices} åbne leverandørfakturaer, {balances} åbningsbalancer, {documents}, {ledger}.',
  'sd.countShown': '{shown}+ {label} (viser {shown} af {total})',
  'sd.label.archiveDocuments': 'arkivdokumenter',
  'sd.label.historyLines': 'historiklinjer',
  'sd.saftTitle': 'Eksport SAF-T',
  'sd.saftHelp': 'Eksportér SAF-T Financial XML (beta), eller importér kontoplan, parter og åbningsbalance fra SAF-T XML.',
  'sd.importSaft': 'Importér SAF-T (MVP)',
});
